/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { muiChevronRight } from '@ally/metronome-icons';
import { Icon } from '../../../Icon';
import { TableCellProvider } from '../../utils';
import { StyledTH, StyledTD } from '../styles';
const CellButton = styled.button `
  ${({ theme: { colors } }) => `
    display: flex;
    align-items: center;
    background: transparent;
    border: none;
    font-weight: bold;
    color: ${colors.bluesuedeshoes};
    cursor: pointer;
  `}
`;
const CellContainer = ({ colIndex, drawer, children, }) => {
    if (colIndex !== 0 || !drawer.colCount) {
        // cells are wrapped in a div to prevent an issue with NVDA
        // sometimes "merging" cells when they are read
        return React.createElement("div", null, children);
    }
    return (React.createElement(CellButton, { onClick: () => drawer.toggle(), "aria-expanded": !!drawer.isOpen, type: "button" },
        React.createElement(Icon, { icon: muiChevronRight, size: "xs", rotate: drawer.isOpen ? 90 : 0, animateRotation: true, ariaHidden: true, mr: "xs" }),
        children));
};
const CellRefForwarding = ({ colIndex, cell, row, cellContext, drawer, children, }, ref) => {
    const isTableRowHeader = useMemo(() => colIndex === 0 && (row === null || row === void 0 ? void 0 : row.enableRowHeaders), [colIndex, row === null || row === void 0 ? void 0 : row.enableRowHeaders]);
    const sharedCellProps = Object.assign(Object.assign({}, cell.getCellProps()), { alignment: cell.column.alignment });
    const sharedCellContainerProps = {
        colIndex,
        drawer,
    };
    return (React.createElement(TableCellProvider, { value: cellContext }, isTableRowHeader ? (React.createElement(StyledTH, Object.assign({ ref: ref }, sharedCellProps, { scope: "row", role: "rowheader", tabIndex: -1 }),
        React.createElement(CellContainer, Object.assign({}, sharedCellContainerProps), children))) : (React.createElement(StyledTD, Object.assign({ ref: ref }, sharedCellProps, { tabIndex: -1 }),
        React.createElement(CellContainer, Object.assign({}, sharedCellContainerProps), children)))));
};
const Cell = React.forwardRef(CellRefForwarding);
export { Cell };
//# sourceMappingURL=Cell.js.map